
import { Vue, Component, Watch } from 'vue-property-decorator';
import { userList } from '../api/wap';
import { load } from '@amap/amap-jsapi-loader';

@Component
export default class User extends Vue {
  list: any = [];
  loading: boolean = false;
  async mounted() {
    if (!window.udid) {
      return this.$router.push('home');
    }
    if (!window.token) {
      window.openApp('mUserLogin');
      return;
    }
    const res: any = await userList(0);
    if (res) {
      this.loading = true;
      this.list = res.data;
      this.list.map((item: any) => {
        if (item.files) {
          item.files = JSON.parse(item.files);
        }
      });
    }
  }
  toDetail(item: any) {
    this.$router.push(`userDetails?id=${item.id}`);
  }
}
